import type { ShipNodeChannel } from './types';

const shipNodeCdn = 'https://cdn.skupreme.com/product/shipnode';

/* The ShipNode (Electron) installers' stable "latest" URLs per channel; a release replaces the file behind them. */
export const ShipNodeDownloads: Record<
  'windows' | 'mac',
  Record<ShipNodeChannel, string>
> = {
  windows: {
    staging: `${shipNodeCdn}/staging/skupreme-shipnode-staging-latest-setup.exe`,
    production: `${shipNodeCdn}/production/skupreme-shipnode-latest-setup.exe`,
  },
  mac: {
    staging: `${shipNodeCdn}/staging/skupreme-shipnode-staging-latest-mac.dmg`,
    production: `${shipNodeCdn}/production/skupreme-shipnode-latest-mac.dmg`,
  },
};

/* Off since EN-3505 released 1.3.0 to production (Windows and Mac). Setting it back to true hides the production
   station list and Add station again and shows only a "coming soon" notice beside the links. */
export const ShipNodeProductionComingSoon = false;
